import {
  ctorsUnion,
  CtorsUnion
} from "@genesys/client-core/lib/constructors-union";
import { MoistureHeatLoadTypeEnum } from "../../../../graphql-types";
import { PageTabs, ViewMode } from "./types";
import * as LoadGroup from "../load-group";

export const Action = ctorsUnion({
  addNewLoadToGroup: (load: LoadGroup.LoadDef) => ({ load }),
  changePageTab: (tab: PageTabs) => ({ tab }),
  dispatchLoadGroup: (
    group: MoistureHeatLoadTypeEnum,
    action: LoadGroup.Action
  ) => ({ action, group }),
  setSelectedLoadGroup: (
    selectedLoadGroup: MoistureHeatLoadTypeEnum | undefined
  ) => ({
    selectedLoadGroup
  }),
  setViewMode: (viewMode: ViewMode) => ({ viewMode })
});

export type Action = CtorsUnion<typeof Action>;
